module.exports = __webpack_public_path__ + "static/media/doctors10-300.7d9f76aa.webp";